import { TagInputProps } from '@/modules/corporate/modules/tags/types';
import {
  CreateEventInput,
  CreateMediaInput,
  EventTypeEnum,
  UpdateEventRecordingsInput,
} from '@/types/schema';

export type EventFormInput = Omit<
  CreateEventInput,
  'tags' | 'type' | 'preWorkContentIds' | 'postWorkContentIds'
> & {
  tags: TagInputProps;
  type?: EventTypeEnum;
  defaultCover?: CreateMediaInput;
  eventRecordings?: UpdateEventRecordingsInput;
};

export enum FormSection {
  Basic = 'BASIC',
  CoverImage = 'COVER_IMAGE',
  Location = 'LOCATION',
  Instructor = 'INSTRUCTOR',
  RegistrationSettings = 'REGISTRATION_SETTINGS',
  AttendanceSettings = 'ATTENDANCE_SETTINGS',
  CompletionSettings = 'COMPLETION_SETTINGS',
  SessionRecording = 'SESSION_RECORDING',
  VisibilitySettings = 'VISIBILITY_SETTINGS',
  Skills = 'SKILLS',
  Certificate = 'CERTIFICATE',
  Tags = 'TAGS',
  NativeSettings = 'NATIVE_SETTINGS',
  Manage = 'MANAGE',
  Prework = 'PREWORK',
  Postwork = 'POSTWORK',
  WorkspaceSettings = 'WORKSPACE_SETTINGS',
  RecurrenceSchedule = 'RECURRENCE_SCHEDULE',
}
